import { Link } from 'react-router-dom';

const WhiteBox = ({ children }) => {
  return (
    <div className="WhiteBox">
      <div className="logo-area">
        <Link to="/">REACTERS</Link>
      </div>
      {children}
    </div>
  );
};

export default WhiteBox;
